import { useEffect } from 'react';

import Decimal from 'decimal.js';
import { useFormContext } from 'react-hook-form';

import { parseToFloat } from '../../../../utils/parseToFloat';

const calculatePercentage = (value: string): number => {
  const floatValue = new Decimal(parseToFloat(value));
  const x = new Decimal(1).minus(floatValue);
  const y = floatValue.dividedBy(x);
  return Math.round(y.times(new Decimal(100)).toNumber());
};

const format = (value: number): string => {
  return `${value} %`;
};

/**
 * Calculates percentage value
 * @param baseField
 * @param percentageField
 */
export const useCalculatePercentage = (
  baseField: string,
  percentageField: string
) => {
  const { setValue, watch } = useFormContext();
  const watchedBased = watch(baseField);
  const watchedPercentage = watch(percentageField);

  useEffect(() => {
    const calculatedPercentage = calculatePercentage(watchedBased);
    setValue(percentageField, format(calculatedPercentage));
  }, [watchedBased, watchedPercentage]);
};
